import React from 'react';
import {
  Link,
  BrowserRouter as Router,
  Route
} from 'react-router-dom';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import logoIcon from './Ackee-Logo.png';

import './App.css';

import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

import Home from './Home';
import About from './About';
import Calendar from './Calendar';
import Partners from './Partners';
import Projects from './Projects';

const App = () => (
  <Router>
    <div>
      <MuiThemeProvider muiTheme={getMuiTheme()}>
        <div className="container">
          <div className="App">

            <div className="App-header">
              <div className="App-logo-icon">
                <Link to={"/"}> <img src={logoIcon} className="logo-icon" alt="logoIcon" /></Link>
              </div>
            </div>

          </div>
        </div>
      </MuiThemeProvider>

      <div className="App-content">
        <Route exact path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/calendar" component={Calendar} />
        <Route path="/partners" component={Partners} />
        <Route path="/projects" component={Projects} />
      </div>
    </div>
  </Router>
)
export default App



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/